import React, { FC } from 'react';
import { required, minValue, NumberInput, TextInput, useTranslate } from 'react-admin';
import { SolutionSelect } from '~/components/ra';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import Alert from '@material-ui/lab/Alert';

interface IndividualInvitationFormProps {
  keyName: string;
}
export const IndividualInvitationForm: FC<IndividualInvitationFormProps> = ({ keyName }) => {
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  const classes = useStyles();
  return (
    <>
      <NumberInput
        label={t('invitationExpirationPeriod')}
        source={`${keyName}.invitationExpirationPeriod`}
        validate={minValue(1)}
      />
      <NumberInput
        label={t('maxNumberOfInvitationsToPhoneNumberPerMonth')}
        source={`${keyName}.maxNumberOfInvitationsToPhoneNumberPerMonth`}
      />
      <NumberInput
        label={t('maxNumberOfInvitationsByActorPerDay')}
        source={`${keyName}.maxNumberOfInvitationsByActorPerDay`}
      />
      <TextInput label={t('termsAndConditionsLink')} source={`${keyName}.termsAndConditionsLink`} />
      <TextInput label={t('websiteLink')} source={`${keyName}.websiteLink`} />
      <TextInput label={t('phoneNumberPrefixes')} source={`${keyName}.phoneNumberPrefixes`} />
      <Alert className={classes.marginBottom} severity='warning'>
        {t('inviteToSolutionWarning')}
      </Alert>
      <SolutionSelect
        label={t('inviteToSolution')}
        source={`${keyName}.solutionId`}
        validate={required()}
        allowEmpty={false}
        variant='individual'
      />
    </>
  );
};
